import { Home, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-purple-50 flex items-center justify-center px-4 py-12 font-quicksand">
      <div className="max-w-2xl w-full text-center">
        {/* Animated 404 */}
        <div className="mb-8 relative">
          <h1 className="text-5xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#FF4523] via-orange-400 to-[#8051FA] leading-none select-none">
            404
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-4 mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#031722] font-poppins">
            Oops! Page Not Found
          </h2>
          <p className="text-lg text-gray-600 max-w-md mx-auto text-center leading-relaxed">
            We couldn't find the page you're trying to reach. Please check the
            URL or return to the homepage.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <button
            onClick={() => navigate("/")}
            className="group flex items-center gap-2 px-6 py-2.5 bg-[#FF4523] text-white rounded-md font-medium hover:bg-[#e63e1f] transition-all duration-300 shadow-md hover:shadow-lg hover:scale-[1.03]"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </button>

          <button
            onClick={() => navigate(-1)}
            className="group flex items-center gap-2 px-6 py-2.5 bg-white text-[#8051FA] border border-[#8051FA] rounded-md font-medium hover:bg-[#8051FA] hover:text-white transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
        </div>

        {/* Decorative Elements */}
        <div className="mt-16 flex justify-center gap-8 opacity-40">
          <div className="w-16 h-16 border-4 border-[#8051FA] rounded-lg rotate-12"></div>
          <div className="w-16 h-16 border-4 border-[#FF4523] rounded-full"></div>
          <div className="w-16 h-16 border-4 border-orange-400 rounded-lg -rotate-12"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;